import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { DomainErrorService } from '@services/domain-error.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-domain-error',
  templateUrl: 'domain-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block }'],
})
export class DomainErrorComponent implements OnInit, OnDestroy {
  @HostBinding() hidden = true;
  readonly error = this.domainErrorService.error;
  private readonly elChange = new MutationObserver(([mutation]) => {
    if (mutation.oldValue !== null) {
      this.elRef.nativeElement.scrollIntoView({
        behavior: 'smooth',
      });
    }
  });
  private errSub: Subscription;

  constructor(
    private readonly domainErrorService: DomainErrorService,
    private readonly elRef: ElementRef<DomainErrorComponent & HTMLElement>,
  ) {}

  ngOnInit(): void {
    this.elChange.observe(this.elRef.nativeElement, { attributeFilter: ['hidden'], attributeOldValue: true });
    this.errSub = this.error.subscribe((e) => {
      this.hidden = e ? false : true;
    });
  }

  ngOnDestroy(): void {
    this.errSub.unsubscribe();
    this.elChange.disconnect();
  }
}
